import { toShortDateHelper } from "./DateHelper";

export const getEvent = function (eventId, eventList) {
  if (eventId) {
    const event = eventList.find((rec) => rec.id === eventId);
    return { ...event, startDateDisplay: toShortDateHelper(event.startDate) };
  }
};
